<section class="devops-placeholder-card" aria-live="polite">
  <h2 class="devops-placeholder-card__title">{{ titleKey() | translate }}</h2>
  <p class="devops-placeholder-card__description">{{ descriptionKey() | translate }}</p>
  <span class="devops-placeholder-card__hint">{{ 'liveDashboard.devops.followUp' | translate }}</span>
</section>
